import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  constructor() { }
}

export class Portfolio {
  portfolioId: number;
  name: string;
  createdDate: string;
  modifiedDate: string;
  description: string;
  allocatedCash: number;
  isActive: boolean;
  investor: Investor;
  stocks: Stock[];
  rebalanceSummary: RebalanceSummary[];
}

export class Stock {
  instrumentId: string;
  name: string;
  symbol: string;
  exchange: string;
  currentPrice: number;
  quantity: number;
  priceLastUpdate: string;
  quantityLastUpdate: string;
}

export class Investor {
  id: number;
  investorId: string;
  clientId: string;
  currentHoldings: Stock[];
  stockHistory: Trade[];
  availableCash: number;
}

export class StockHistory {
  tradeId: number;
  quantity: number;
  price: number;
  purchaseDate: string;
  brokerage: number;
  tradeType: string;
  instrumentId: string;
  isin: string;
}

export class RebalanceSummary {
  rebalanceSummaryId: number;
  tradeId: string;
  tradeDate: string;
  createdDate: string;
  netWorth: number;
  rebalanceTechniqueType: string;
  status: string;
  transactionId: string;
  rebalanceStocks: RebalanceStocks[];
}

export class RebalanceStocks {
  rebalanceStockId: number;
  tradeId: string;
  instrumentId: string;
  expectedQuantity: number;
  weightage: number;
  requiredTransaction: number;
  tradeType: string;
  tradeStatus: string;
}

export class Rebalance {
  portfolioId: number;
  rebalanceStocks: RebalanceStock[];
}

export class RebalanceStock {
  stock: Stock;
  expectedWeight: number;
}

export class Trade {
  tradeId: number;
  quantity: number;
  price: number;
  purchaseDate: string;
  brokerage: number;
  tradeType: string;
}